export default __webpack_public_path__ + "static/sway-top-9f4a8c648550d4676ac35db13b0aac20.jpg";